<template>
  <!--  <v-carousel-->
  <!--    class="mx-4"-->
  <!--    hide-delimiters-->
  <!--    height="200"-->
  <!--  >-->
  <!--    <v-carousel-item-->
  <!--      src="https://images.unsplash.com/photo-1575835016110-371330ca0dee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"-->
  <!--    />-->
  <!--    <v-carousel-item-->
  <!--      src="https://images.unsplash.com/photo-1575779861881-3ab8a7eee680?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"-->
  <!--    />-->
  <!--    <v-carousel-item-->
  <!--      src="https://images.unsplash.com/photo-1575714939293-005a069a0991?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"-->
  <!--    />-->
  <!--  </v-carousel>-->
  <v-card
    flat
    color="warning"
    class="ma-4"
  >
    <v-card-title>
      Important COVID19
    </v-card-title>
    <v-card-text>
      <p class="ma-0">
        Les réponses à <strong>toutes requêtes de disponibilités / tarifs</strong> se font indépendamment des <strong>restrictions
          d’accueil</strong> des
        voyageurs en <strong>fonction de leur pays d’origine</strong>.
        Par conséquent, <strong>avant tout achat</strong>, nous vous invitons à prendre <strong>renseignement sur le
          site du gouvernement</strong>&nbsp;
        <a
          href="http://www.diplomatie.gouv.fr/"
        >www.diplomatie.gouv.fr</a>
        ainsi qu’auprès des <strong>ambassades</strong> ou <strong>consulats de votre pays de destination</strong>.
        En tant que <strong>mandataire des compagnies aériennes</strong>, votre <strong>agence de voyages appliquera les
          conditions définies par
          les compagnies aériennes en cas d’infaisabilité du voyage</strong>.
        <strong>Attention</strong> : Si vous <strong>disposez d’un avoir</strong> auprès d’une compagnie aérienne,
        celui-ci <strong>ne sera pas utilisable via
          cette
          application en ligne</strong>.
        Merci de vous <strong>renseigner</strong> auprès de <strong>l’agence de voyages émettrice</strong> de votre
        <strong>réservation initiale</strong>.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Advertisements'
}
</script>

<style scoped>
.v-carousel {
  border-radius: 5px;
  width: calc(100% - 32px);
}
</style>
